import { Link } from "../common/Link";
import styled, { css } from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2.5em;
  font-size: 10px;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.85);
  user-select: none;
  z-index: 20000;
  overflow: auto;

  @media (max-width: 959px) {
    padding: 1.5em;
    font-size: 8px;
  }

  @media (max-width: 480px) {
    font-size: 7px;
  }
`;

export const PopupView = styled.div`
  position: relative;
  flex-shrink: 1;
  width: 70em;
  max-width: 90%;
  max-height: 100%;
  margin: 0 auto;
  padding: 3.5em 4em 2em;
  text-align: center;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 1);
  overflow: auto;

  @media (max-width: 760px) {
    width: 95%;
    max-width: 95%;
    padding: 25px 10px 15px 10px;
  }
`;

export const Close = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  width: 20px;
  height: 20px;
  color: #a0a7b2;
  background-size: cover;
  transition: all 0.3s ease;
  cursor: pointer;

  :before,
  :after {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    width: 0;
    height: 25px;
    border-left: 1px solid currentColor;
  }

  :before {
    transform: translateX(-50%) rotate(45deg);
    transform-origin: 100%;
  }
  :after {
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 0;
  }

  :hover {
    color: #60a31c;
  }
`;

export const Title = styled.h3`
  margin-bottom: 20px;
  padding-top: 30px;
  font-weight: bold;
  font-size: 20px;
  line-height: 1.42;
  color: #feac00;
  text-align: center;

  @media (max-width: 760px) {
    padding-top: 20px;
    font-size: 18px;
    line-height: 1.2;
  }
`;

export const Bold = styled.span`
  font-weight: bold;
  color: #60a31c;
`;

// prettier-ignore
export const SafeImg = styled.img`
  @media (max-width: 760px) {
    width: 64px;
  }

  @media (max-width: 760px) and (orientation: landscape) {
    display: none;
  }
`;

export const Subtitle = styled.p`
  max-width: 500px;
  margin: 0 auto;
  font-size: 20px;
  line-height: 1.3;
  color: #343434;

  @media (max-width: 760px) {
    font-size: 18px;
    line-height: 1.2;
  }
`;

export const Info = styled.p`
  max-width: 500px;
  margin: 3px auto 0;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: #717171;
  line-height: 1.2;
  text-align: center;

  @media (max-width: 760px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};
  }
`;

export const InlineContainer = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 100%;
  padding-top: 30px;
  font-size: 0.1px;
  line-height: 0;

  @media (max-width: 760px) {
    padding-top: 20px;
  }
`;

export const InlineBlock = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 50%;

  @media (max-width: 479px) {
    width: 100%;
    margin-bottom: 15px;
  }
`;

export const RealContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: ${props => (props.margin ? "25px" : "10px")};
`;

export const Button = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 119px;
  min-height: 39px;
  margin-left: ${props => (props.real ? "12px" : 0)};
  padding: 0 5px;
  font-weight: bold;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
  background: linear-gradient(
    to bottom,
    ${props => (props.green ? "#68C703, #60A31D" : "#FEAC00, #FD9600")}
  );
  text-decoration: none;

  @media (max-width: 359px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "14px"};
  }

  :hover,
  :focus {
    background: linear-gradient(
      to bottom,
      ${props => (props.green ? "#60A31D, #68C703" : "#FD9600, #FEAC00")}
    );
  }

  :active {
    background: linear-gradient(
      to bottom,
      ${props => (props.green ? "#68C703, #60A31D" : "#FEAC00, #FD9600")}
    );
  }

  ${props =>
    props.disabled &&
    css`
      background: linear-gradient(
        to bottom,
        #8a8a8a 0%,
        #a5a5a5 100%
      ) !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
    `};

  ${props =>
    props.demo &&
    css`
      width: 90%;
      margin: 0 auto;
    `};
`;

export const HelpContainer = styled.div`
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: #717171;
  text-align: center;

  @media (max-width: 760px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};
  }
`;

export const HelpLink = styled(Link)`
  color: #3598db;
  text-decoration: underline;
  cursor: pointer;

  :hover {
    text-decoration: none;
  }
`;

export const ButtonDesc = styled.p`
  padding-top: 12px;
  font-weight: 400;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 20px;
  text-align: center;
  color: #717171;

  @media (max-width: 760px) {
    padding-top: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/InsufficientPopup/StyledComponents.js